import logo from './logo.svg';
import './App.css';
import LadinPage from './Routers/LadinPage/LadinPage';
import AppNavigation from './Routers/AppNavigation';

function App() {
  return (
    <div>
     <AppNavigation/>
    </div>
  );
}

export default App;
